import React from 'react';

export default function Copyright() {
  return (
    <div className="copyright">
      <span>Copyright © 2021 PT.Integrity All Rights Reserved.</span>
    </div>
  );
}
